import api from './utilBackoffice';

const controller = 'RedeLojaNaoContabilizar';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  Create: dto => {
    return api.Axios.Post(url, dto);
  },
  Update: dto => {
    return api.Axios.Post(url + '/Update', dto);
  },
  Listar: dto => {
    return api.Axios.GetParams(url, dto);
  }
});
